// extracted by mini-css-extract-plugin
export default {"dropdown":"style_dropdown__KsUuR","avatar":"style_avatar__ti4sf"};